import { render } from "./BlogList.vue?vue&type=template&id=5de13f34&scoped=true"
import script from "./BlogList.vue?vue&type=script&lang=js"
export * from "./BlogList.vue?vue&type=script&lang=js"

import "./BlogList.vue?vue&type=style&index=0&id=5de13f34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de13f34"]])

export default __exports__